import {createAction, props} from "@ngrx/store";


export const setActiveGameCategoryId = createAction(
  '[Student] Set Active Game Category Id',
  props<{ gameCategoryId: number }>()
);

export const setActiveClassIdStudent = createAction(
  '[Student] Set Active Class Id',
  props<{ classId: string }>()
);
